var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhitelink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47106 12.2423L7.52825 13.1851C6.2265 14.4868 4.11595 14.4868 2.8142 13.1851C1.51245 11.8834 1.51245 9.7728 2.8142 8.47106L3.75701 7.52825M12.2423 8.47106L13.1851 7.52825C14.4868 6.2265 14.4868 4.11595 13.1851 2.8142C11.8834 1.51245 9.7728 1.51245 8.47106 2.8142L7.52825 3.75701M5.66632 10.333L10.333 5.6663",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitelink);
export default __webpack_public_path__ + "static/media/whitelink.36b83af8ec5508fc5c7afb56a75fdfc0.svg";
export { ForwardRef as ReactComponent };